import React from 'react';
import type { BombiixIconProps } from './types';

/**
 * Bombiix Product Group icon — three stacked product cubes.
 * Uses `currentColor` so the parent `.bombiix-icon-container` modifier drives the tint.
 */
const ProductGroupIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    {...rest}
  >
    <path
      d="M3.40039 14.309L6.09961 15.4047V12.1117L3.40039 11.015V14.309ZM6.90039 12.1117V15.4047L9.59961 14.309V11.015L6.90039 12.1117ZM4.06055 10.4213L6.5 11.4115L8.93848 10.4213L6.5 9.43008L4.06055 10.4213ZM10.4004 14.5775C10.4004 14.7403 10.3012 14.8864 10.1504 14.9477L6.65039 16.3695C6.55385 16.4088 6.44615 16.4088 6.34961 16.3695L2.84961 14.9477C2.69882 14.8864 2.59961 14.7403 2.59961 14.5775V10.4213C2.59961 10.2585 2.69882 10.1124 2.84961 10.0512L6.34961 8.6293L6.42383 8.60684C6.49941 8.59217 6.57804 8.59991 6.65039 8.6293L10.1504 10.0512C10.3012 10.1124 10.4004 10.2585 10.4004 10.4213V14.5775Z"
      fill="currentColor"
    />
    <path
      d="M10.9004 14.309L13.5996 15.4047V12.1117L10.9004 11.015V14.309ZM14.4004 12.1117V15.4047L17.0996 14.309V11.015L14.4004 12.1117ZM11.5605 10.4213L14 11.4115L16.4385 10.4213L14 9.43008L11.5605 10.4213ZM17.9004 14.5775C17.9004 14.7403 17.8012 14.8864 17.6504 14.9477L14.1504 16.3695C14.0539 16.4087 13.9461 16.4087 13.8496 16.3695L10.3496 14.9477C10.1988 14.8864 10.0996 14.7403 10.0996 14.5775V10.4213C10.0996 10.2585 10.1988 10.1124 10.3496 10.0512L13.8496 8.6293L13.9238 8.60684C13.9994 8.59217 14.078 8.59991 14.1504 8.6293L17.6504 10.0512C17.8012 10.1124 17.9004 10.2585 17.9004 10.4213V14.5775Z"
      fill="currentColor"
    />
    <path
      d="M6.90039 8.80899L9.59961 9.90469V6.61172L6.90039 5.51504V8.80899ZM10.4004 6.61172V9.90469L13.0996 8.80899V5.51504L10.4004 6.61172ZM7.56055 4.92129L10 5.91152L12.4385 4.92129L10 3.93008L7.56055 4.92129ZM13.9004 9.07754C13.9004 9.24031 13.8012 9.38638 13.6504 9.44766L10.1504 10.8695C10.0539 10.9087 9.94615 10.9087 9.84961 10.8695L6.34961 9.44766C6.19882 9.38638 6.09961 9.24031 6.09961 9.07754V4.92129C6.09961 4.75852 6.19882 4.61244 6.34961 4.55117L9.84961 3.1293L9.92383 3.10684C9.99941 3.09217 10.078 3.09991 10.1504 3.1293L13.6504 4.55117C13.8012 4.61244 13.9004 4.75852 13.9004 4.92129V9.07754Z"
      fill="currentColor"
    />
  </svg>
);

export default ProductGroupIcon;
